const siteHeader = document.querySelector('header.site-header');
const menuTrigger = document.querySelector('.menuTrigger');
menuTrigger.addEventListener('click', () => {
    siteHeader.classList.toggle('is-open');
});

// close menu layer when clicking .menu links
const menuLinks = document.querySelectorAll('.menu a');
menuLinks.forEach(link => {
    link.addEventListener('click', () => {
        siteHeader.classList.remove('is-open');
    });
});

// Define debounce function
function debounce(func, wait) {
    let timeout;
    return function(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Add scroll event listener to header to add .scroll class if scrolled down more than 100px
window.addEventListener('scroll', () => {
    if (window.scrollY > 40) {
        siteHeader.classList.add('scroll');
    } else {
        siteHeader.classList.remove('scroll');
    }
});